import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './DropdownHolder.css';
import { SecondaryButton, Button } from '../../../../components';
import { IconChevronRightStrongL } from '../../../../icons';
import classNames from 'classnames';
import { FIND_HORSE, FIND_SUPPORT } from './dropdowns';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

export default ({ children, dropdownId, isMobile, isOpen, onClose, rootClassName }) => {
    const showRegisterButton = dropdownId === FIND_HORSE || dropdownId === FIND_SUPPORT;
    const history = useHistory();

    const navigate = () =>
        history.push(
            createResourceLocatorString(
                dropdownId === FIND_HORSE ? 'SignupRider' : 'SignupHorseowner',
                routeConfiguration(),
                {},
                {}
            )
        );

    if (isMobile) {
        return (
            <div
                className={classNames(css.root, css.mobileRoot, {
                    [rootClassName]: !!rootClassName,
                    [css.mobileRootOpen]: isOpen,
                })}
            >
                <SecondaryButton className={css.closeModalBtn} onClick={onClose}>
                    <IconChevronRightStrongL />
                    <span>Zurück</span>
                </SecondaryButton>
                <div className={css.content}>{children}</div>
                {showRegisterButton && (
                    <div className={css.mobFooter}>
                        <Button onClick={navigate}>Kostenlos registrieren</Button>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div
            className={classNames(css.root, {
                [rootClassName]: !!rootClassName,
            })}
        >
            <div className={css.content}>{children}</div>
            {showRegisterButton && (
                <footer>
                    <p className={css.registerAction} onClick={navigate}>
                        <span>Kostenlos registrieren </span>
                        <IconChevronRightStrongL />
                    </p>
                </footer>
            )}
        </div>
    );
};
